import { SxProps, Theme } from '@mui/material';
import { atlasCore, atlasSemantic } from 'src/theme/atlas/tokens';
import { typographySemantic } from 'src/theme/atlas/typography';

const FIELD_MIN_WIDTH = 180;
const LOGIC_WIDTH = 80;

export const popoverPaper: SxProps<Theme> = {
  backgroundColor: 'common.white',
  color: 'text.primary',
  borderRadius: '8px',
  boxShadow:
    '0px 6px 6px 0px rgba(0,0,0,0.16), 0px 0px 1px 0px rgba(0,0,0,0.4)',
  maxWidth: 'calc(100vw - 32px)',
  overflow: 'auto',
};

export const container: SxProps<Theme> = {
  padding: atlasCore.spacing[2],
  minWidth: 480,
};

export const row: SxProps<Theme> = {
  alignItems: 'flex-end',
};

export const field: SxProps<Theme> = {
  minWidth: FIELD_MIN_WIDTH,
};

export const logicControl: SxProps<Theme> = {
  width: LOGIC_WIDTH,
  flexShrink: 0,
};

export const removeIcon: SxProps<Theme> = {
  color: atlasSemantic.color.type.muted,
};

export const placeholderText: SxProps<Theme> = {
  color: atlasSemantic.color.type.disabled,
  fontSize: typographySemantic.body.fontSize,
  lineHeight: 'inherit',
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const footerButton: SxProps<Theme> = {
  '&.MuiButton-text': {
    color: atlasSemantic.color.type.default,
  },
};

export const footer: SxProps<Theme> = {
  marginTop: atlasCore.spacing[3],
  alignItems: 'center',
};
